import React, { useState, useEffect } from "react";
import Modal from "../../Order/Modal";
import axios from "axios";
// import { toast } from "react-toastify";
import Cookies from "js-cookie";
import { FaUpload } from "react-icons/fa";
import {Notification} from "../../Notification"

const CodUploadPoopup = ({ onClose, setRefresh }) => {
  const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const [selectedFile, setSelectedFile] = useState(null);
  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file); // Updates state, but state change is asynchronous
      console.log("Selected file:", file.name);
    }
  };

  const handleSubmit = async () => {
    try {
      const formData = new FormData();
      formData.append("file", selectedFile);
      const token = Cookies.get("session");
      const response = await axios.post(
        `${REACT_APP_BACKEND_URL}/cod/upload`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("Upload success:", response);
      Notification(response.data.message,"success")
      setRefresh(true)
      onClose();
    } catch (err) {
      Notification(err.response?.data?.error,"error")
      // console.log(err.response?.data?.error || "Upload failed");
    }
  };

  //   };
  const handleDownload = async () => {
    try {
      const token = Cookies.get("session");
      const response = await axios.get(
        `${REACT_APP_BACKEND_URL}/cod/download-excel`,
        {
          responseType: "blob",
          headers: {
            authorization: `Bearer ${token}`,
          },

          // Important: tells Axios to handle binary data
        }
      );

      // Convert response data to a Blob
      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });
      const url = window.URL.createObjectURL(blob);

      // Create a temporary link and trigger the download
      const a = document.createElement("a");
      a.href = url;
      a.download = "COD_Remittance_Sample_Format.xlsx"; // Set the file name
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      // Free up memory by revoking the object URL
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };
  return (
    <div className="fixed inset-0 w-full h-full z-[1000] flex items-center justify-center bg-gray-500 animate-popup-in bg-opacity-50">
      <div className="bg-white p-4 rounded-lg shadow-lg w-[400px] relative">
        <h2 className="text-[12px] sm:text-[14px] font-bold mb-2">Upload Cod Remittance</h2>

        <p className="text-[10px] sm:text-[12px]">
          Download Sample file{" "}
          <button
            onClick={handleDownload}
            className="text-brand-primary hover:underline cursor-pointer"
          >
            click here{" "}
          </button>
          {/* <span className="text-purple-500 cursor-pointer">click here</span> */}
        </p>

        <label className="cursor-pointer flex text-[10px] sm:text-[12px] items-center gap-2 text-brand-primary bg-white px-3 py-2 mt-4 rounded-lg border border-brand-primary transition">
          <div className="flex justify-between items-center w-full">
            <span>Upload File</span>
            <FaUpload className="text-brand-primary" />
          </div>
          <input type="file" className="hidden" onChange={handleFileChange} />
        </label>

        {selectedFile && (
          <p className="text-[10px] sm:text-[12px] text-gray-700">Selected: {selectedFile.name}</p>
        )}
        <button onClick={handleSubmit} className="px-3 py-2 me-2 font-[600] hover:opacity-90 mt-2 bg-brand-primary text-white rounded-lg text-[10px] sm:text-[12px]">
          Submit
        </button>

        {/* Move Close Button inside modal */}
        <button
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-800"
          onClick={onClose}
        >
          ✖
        </button>
      </div>

      {/* <div className="mt-4"></div> */}
    </div>
  );
};

export default CodUploadPoopup;
